const LIBRARY_FILTERS_API = '/savedfilter/getlibraryitemsjson';
const LIBRARY_FILTERS_DELETE_API = '/savedfilter/deletejson';

const REQUEST_LIBRARY_FILTERS_LIST = 'REQUEST_LIBRARY_FILTERS_LIST';
const COMPLETE_LIBRARY_FILTERS_LIST = 'COMPLETE_LIBRARY_FILTERS_LIST';
const LIBRARY_FILTERS_DELETE_ITEM = 'LIBRARY_FILTERS_DELETE_ITEM';

export {
	REQUEST_LIBRARY_FILTERS_LIST,
	COMPLETE_LIBRARY_FILTERS_LIST,
	LIBRARY_FILTERS_DELETE_ITEM,
	LIBRARY_FILTERS_API,
	LIBRARY_FILTERS_DELETE_API,
};
